import AdLabel from '@/components/AdLabel/AdLabel'
import { Image } from '@/components/Image'
import { Typography } from '@/components/Typography'
import { toKebabCase } from '@/utils/string'
import { type ImageData } from '@/elements/widgets/external/ExternalInline'
import styles from './ShopTeaser.module.scss'
import { getAppConfig } from '@/config/config'

export type Offer = {
  readonly seller: string
  readonly price: string
  readonly listPrice?: string
  readonly url: string
}

export type ShopMultiTeaserProps = {
  nofollow?: string
  price?: string
  listPrice?: string
  txt?: string
  imageData?: ImageData
  imgSrc?: string
  offers: Array<Offer>
}

const ShopTeaserMulti = ({ props }: { props: ShopMultiTeaserProps }) => {
  const { nofollow, txt, imageData, imgSrc, offers } = props
  const config = getAppConfig()

  return (
    <div>
      <AdLabel />
      <div className={styles.teaser}>
        {(imageData || imgSrc) && (
          <div className={styles.media}>
            <div>
              {imageData && <Image image={imageData} alt={imageData.filename} />}
              {imgSrc && <img src={imgSrc} alt="" />}
            </div>
          </div>
        )}
        <div className={styles.content}>
          {txt && (
            <Typography as="span" variant="m">
              {txt}
            </Typography>
          )}
          <div className={styles.offers}>
            {offers.map((offer, idx) => {
              const contextId = toKebabCase(`${offer.seller}-${offer.url}`) + idx
              return (
                <div className={styles.offer} key={contextId}>
                  <div className={styles['price-logo']}>
                    <div className={styles['multi-price']}>
                      <Typography as="span" variant="m" weight="bold">
                        {offer.price}
                      </Typography>
                      {offer.listPrice && (
                        <Typography as="span" variant="s">
                          {offer.listPrice}
                        </Typography>
                      )}
                    </div>
                    <div className={styles.seller}>
                      <img
                        src={`${config.basePath}/assets/shopLogos/shoplogo-${offer.seller}.svg`}
                        alt={offer.seller}
                      />
                    </div>
                  </div>
                  <a href={offer.url} target="_blank" rel={nofollow && nofollow === 'true' ? 'nofollow' : undefined}>
                    <button className="button primary">Zum Angebot</button>
                  </a>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ShopTeaserMulti
